//
//
//
//
//
//
//
//
//
//
export default {
  name: 'LoopingRhombusesSpinner',
  props: {
    animationDuration: {
      type: Number,
      "default": 2500
    },
    rhombusSize: {
      type: Number,
      "default": 15
    },
    color: {
      type: String,
      "default": '#fff'
    }
  },
  data: function data() {
    return {
      rhombusesNum: 3
    };
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: "".concat(this.rhombusSize, "px"),
        width: "".concat(this.rhombusSize * 4, "px")
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: "".concat(this.rhombusSize, "px"),
        width: "".concat(this.rhombusSize, "px"),
        backgroundColor: this.color,
        animationDuration: "".concat(this.animationDuration, "ms"),
        left: "".concat(this.rhombusSize * 4, "px")
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delay = -this.animationDuration / 1.5;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        var style = Object.assign({
          animationDelay: "".concat(i * delay, "ms")
        }, this.rhombusStyle);
        rhombusesStyles.push(style);
      }

      return rhombusesStyles;
    }
  }
};